import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { collection, query, where, getDocs, limit as fsLimit } from 'firebase/firestore'
import { db } from '@/lib/firebase'
import { Loader } from 'lucide-react'

export default function WaitlistLandingPage() {
  const { artistDisplayName } = useParams<{ artistDisplayName: string }>()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const findArtistAndRedirect = async () => {
      if (!artistDisplayName) {
        setError('Artist name not provided')
        setLoading(false)
        return
      }

      try {
        // Find artist by displayName
        const artistsRef = collection(db, 'artists')
        const artistQuery = query(
          artistsRef,
          where('displayName', '==', artistDisplayName),
          fsLimit(1)
        )
        
        const snapshot = await getDocs(artistQuery)
        
        if (snapshot.empty) {
          setError('Artist not found')
          setLoading(false)
          return
        }

        const artistDoc = snapshot.docs[0]
        const artistId = artistDoc.id

        // Redirect to artist profile with waitlist mode enabled
        navigate(`/artist/${artistId}?waitlistMode=true`, { replace: true })
      } catch (err) {
        console.error('Error finding artist:', err)
        setError('Failed to load artist profile')
        setLoading(false)
      }
    }

    findArtistAndRedirect()
  }, [artistDisplayName, navigate])

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-background">
        <Loader className="w-8 h-8 animate-spin text-primary" />
        <p className="mt-4 text-muted-foreground">Loading artist...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-background">
        <p className="text-lg font-semibold text-destructive mb-2">Error</p>
        <p className="text-muted-foreground">{error}</p>
      </div>
    )
  }

  return null
}

